import _ from "underscore";

export default class TreeNodeSet {
    constructor() {
        this.map = {};
    }

    clone() {
        const target = {};
        for (let level in this.map) {
            //noinspection JSUnfilteredForInLoop
            const sourceObj = this.map[level];
            const targetObj = {};

            for (let id in sourceObj) {
                //noinspection JSUnfilteredForInLoop
                targetObj[id] = sourceObj[id];
            }

            //noinspection JSUnfilteredForInLoop
            target[level] = targetObj;
        }

        const result = new TreeNodeSet();
        result.map = target;

        return result;
    }

    add(treeNode) {
        const levelMap = this.getLevelMap(treeNode.getLevel());
        levelMap[treeNode.getId()] = treeNode;
    }

    remove(treeNode) {
        const levelMap = this.getLevelMap(treeNode.getLevel());
        delete levelMap[treeNode.getId()];
    }

    contains(treeNode) {
        const levelObj = this.map[treeNode.getLevel()];
        return levelObj && levelObj[treeNode.getId()] ? true : false;
    }

    containsAll(treeNodes) {
        for (let node of treeNodes)
            if (!this.contains(node))
                return false
        return true
    }

    isEmpty() {
        for (let level in this.map)
            if (!this.isLevelEmpty(level))
                return false;
        return true;
    }

    isLevelEmpty(level) {
        if (!this.map[level])
            return true;
        //noinspection LoopStatementThatDoesntLoopJS, JSUnusedLocalSymbols
        for (let p in this.map[level])
            return false;
        return true;
    }

    getLevelMap(level) {
        let levelMap = this.map[level];
        if (!levelMap) {
            levelMap = {};
            this.map[level] = levelMap;
        }
        return levelMap;
    }

    getAllLevels() {
        const levels = [];

        for (let level in this.map)
            levels.push(level);

        return levels;
    }

    getAllNodes() {
        const nodes = [];
        _.each(_.values(this.map), function(levelMap) {
            _.each(_.values(levelMap), function(node) {
                nodes.push(node);
            });
        });

        return nodes;
    }

    addAll(otherTreeNodeSet) {
        for (let level in otherTreeNodeSet.map) {
            //noinspection JSUnfilteredForInLoop
            const sourceObj = otherTreeNodeSet.map[level];
            //noinspection JSUnfilteredForInLoop
            const targetObj = this.getLevelMap(level);
            for (let id in sourceObj)
                    //noinspection JSUnfilteredForInLoop
                targetObj[id] = sourceObj[id];
        }
    }

    makePathsNodeSet() {
        const target = {};
        _.each(this.getAllNodes(), function(node) {
            let parent = node.getParent();
            while (parent) {
                let targetObj = target[parent.getLevel()];
                if (!targetObj) {
                    targetObj = {};
                    target[parent.getLevel()] = targetObj;
                }

                targetObj[parent.getId()] = parent;

                parent = parent.getParent();
            }
        });

        const result = new TreeNodeSet();
        result.map = target;
        return result;
    }

    getNodeIds(level) {
        const result = [];
        if (this.map[level])
            for (let p in this.map[level])
                result.push(p);
        return result
    }

    intersection(treeNodeSet) {
        const result = new TreeNodeSet();

        for (let level in this.map) {
            //noinspection JSUnfilteredForInLoop
            const levelObj = this.map[level];
            for (let id in levelObj) {
                //noinspection JSUnfilteredForInLoop
                const node = levelObj[id];
                if (treeNodeSet.contains(node))
                    result.add(node);
            }
        }

        return result;
    }

    union(treeNodeSet) {
        const result = this.clone();
        result.addAll(treeNodeSet);
        return result;
    }

    equals(other) {
        const self = this;
        const selfNodes = self.getAllNodes();
        const otherNodes = other.getAllNodes();
        return selfNodes.length === otherNodes.length &&
               _.all(selfNodes, function(node) { return other.contains(node) }) &&
               _.all(otherNodes, function(node) { return self.contains(node) });
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TreeNodeSet.js